function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-2-3h16v16H-2z"
}), React.createElement("path", {
  fill: "#D14B08",
  d: "M6.857.43l4.234 7.056A1 1 0 0110.234 9H1.766A1 1 0 01.91 7.486L5.143.429a1 1 0 011.714 0z"
}));

var SvgBulletShape3 = function SvgBulletShape3(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgMTIgOSI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik0tMi0zaDE2djE2SC0yeiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNEMTRCMDgiIGQ9Ik02Ljg1Ny40M2w0LjIzNCA3LjA1NkExIDEgMCAwIDEgMTAuMjM0IDlIMS43NjZBMSAxIDAgMCAxIC45MSA3LjQ4Nkw1LjE0My40MjlhMSAxIDAgMCAxIDEuNzE0IDB6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgBulletShape3 as ReactComponent };